import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface ExtensionQueueJob {
  job_id: string;
  title: string;
  company: string;
  location: string;
  description: string;
  url: string;
  salary?: string;
  remote?: string;
  job_type?: string;
  logo?: string;
}

export function useExtensionQueue() {
  const [loading, setLoading] = useState(false);

  const addToExtensionQueue = async (job: ExtensionQueueJob) => {
    setLoading(true);
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error('Please log in to use auto-apply');
        return;
      }

      const { error } = await supabase.from('extension_tasks').insert([{
        user_id: user.id,
        job_url: job.url,
        payload: {
          job_id: job.job_id,
          title: job.title,
          company: job.company,
          location: job.location,
          description: job.description,
          salary: job.salary,
          remote: job.remote,
          job_type: job.job_type,
          logo: job.logo,
        } as any,
        status: 'pending' as any,
      }]);

      if (error) throw error;

      toast.success(`"${job.title}" added to extension queue`);
    } catch (err: any) {
      console.error('Extension queue error:', err);
      toast.error(err.message || 'Failed to add job to extension queue');
    } finally {
      setLoading(false);
    }
  };

  return { addToExtensionQueue, loading };
}
